"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var page_layout_1 = __importDefault(require("./page-layout"));
__export(require("./page-layout"));
exports.default = page_layout_1.default;
//# sourceMappingURL=index.js.map